import { useQuery } from 'react-query';
import apiUrl from 'common/api-url';
import { get } from 'reduxStore/apiService';
import App from 'common/backbone-app';

export type DAC7ReportList = {
  values: string[];
};

export const useReportList = () => {
  const supplierId = App.getSupplierId();
  const { isLoading, data } = useQuery<DAC7ReportList>(['dac7-reports', supplierId], () => {
    return get<DAC7ReportList>(apiUrl('DAC7_REPORTS_LIST', { supplierId }));
  });

  return {
    isLoading,
    reports: data,
  };
};
